module.exports = __webpack_public_path__ + "static/media/chris-villa.76fa9ac6.jpg";